module.exports = __webpack_public_path__ + "static/media/lightbulb-regular.959011ee.svg";